package com.cybersoftsolution.cybersoftsolutionweb.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.bars.SubscribeBarCollapsable
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.FooterSectionLinearGradientStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.FooterSectionRadialGradientStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Rotate_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SubscribeBarCollapsableStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun FooterSection(
    sections: List<PageSection>,
    setOverFlowSectionsMenu: (List<PageSection>) -> Unit = {},
    pageSection: PageSection,
    menuIcon: Resources.FaIconsClassName? = null,
    brandIcon: String? = null,
    brandLogo: String? = null,
    searchText: String = "",
    setSearchText: (String) -> Unit = {},
    onSearch: (text: String,category: String?) -> Unit = { _, _ -> },
    searchCategory: Category? = null,
    onMenuClick: () -> Unit = {},

    ///subscribing
    isSubscribe: Boolean = false,
    isSubscribing: Boolean = false,
    email: String = "",
    onEmailChange: (String) -> Unit = {},
    onSubscribe: (email: String) -> Unit = {},
    onUnSubscribe: (email: String) -> Unit = {}
) {

    val breakpoint = rememberBreakpoint()
    val desktop = isDesktop()
    var rememberStyle by remember { mutableStateOf(
        if (desktop) {
            FooterSectionRadialGradientStyle
        } else {
            FooterSectionLinearGradientStyle
        }
    ) }

    LaunchedEffect(breakpoint) {
        rememberStyle =         if (desktop) {
            FooterSectionRadialGradientStyle
        } else {
            FooterSectionLinearGradientStyle
        }
    }





    Column  (
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
        modifier = rememberStyle.toModifier()
            .id(pageSection.id.orEmpty())
            .fillMaxWidth()
//            .height(150.px)
            .padding(leftRight = if (isDesktop()) {30.px} else {5.px})
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .zIndex(9) //posicionamiento de panel lateral sobre el contenido principal
    ) {

        SimpleGrid(
            modifier = Modifier
                .margin(topBottom = 10.px)
//                .fillMaxHeight(90.percent)
//                    .fillMaxWidth(if (isDesktop()) {70.percent} else {100.percent}),
                .fillMaxWidth(),
            numColumns = numColumns(base = 1, sm = 1, md = 1 , lg = 3 )
        ){

            repeat(3) { asa ->
                Box (
                    contentAlignment = Alignment.Center,
                    modifier = Modifier
                        .fillMaxWidth(100.percent)
                        .fillMaxHeight()
                ) {
                    Column(
                        verticalArrangement = Arrangement.Top,
                        horizontalAlignment = Alignment.CenterHorizontally,
                        modifier = Modifier
                            .fillMaxWidth(if (isDesktop()) {80.percent} else {100.percent})
                            .fillMaxHeight()
                            .margin(leftRight = if (isDesktop()) {20.px} else {0.px} , topBottom = if (isDesktop()) {0.px} else {20.px})
                    ) {
                        when (asa) {
                            0 -> {SocialSubSection()}
                            1 -> {AboutUsSubSection()}
                            2 -> {
                                Column(
                                    modifier = Modifier.fillMaxSize(),
                                    verticalArrangement = Arrangement.SpaceBetween,
                                    horizontalAlignment = Alignment.CenterHorizontally,
                                ) {

                                    SubscribeSubSection(
                                        isSubscribe = isSubscribe,
                                        email = email,
                                        onEmailChange = onEmailChange,
                                        onSubscribe = onSubscribe,
                                        onUnSubscribe = onUnSubscribe,
                                        isSubscribing = isSubscribing,
                                    )

                                    DownloadAppSubSection()



                                }





                            }
                        }



                    }
                }

            }




        }


        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {

            SpanText(
                modifier = Modifier
                    .fontSize(16.px)
                    .fillMaxWidth()
                    .textAlign(TextAlign.Center)
                    .color(Theme.HalfWithe.rgb)
                    .fontStyle(FontStyle.Italic)
                    .margin(topBottom = 10.px),
                text = "Copyright © 2025 Cyber Soft Solution | Todos los derechos reservados"
            )


        }

    }



}
    @Composable
    fun SocialSubSection(
        socialIconSize:Int = 32
    ){


        Column(
            verticalArrangement = Arrangement.SpaceBetween,
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier.fillMaxSize()
        ) {
            Column {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center,
                    modifier = Selected_ItemStyle
                        .toModifier()
                        .cursor(Cursor.Pointer)
                ) {
                    MyFaIcon(
                        id = "phoneSocialIconId",
                        modifier = Modifier.margin(leftRight = 5.px),
                        size = 20,
                        faIconsClassName = Resources.FaIconsClassName.Phone_ICO
                    )
                    SpanText(
                        modifier = Modifier
                            .fontSize(15.px)
                            .fontStyle(FontStyle.Normal)
                            .margin(topBottom = 10.px),
                        text = "(+1) 305 360 5449"
                    )
                }
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center,
                    modifier = Selected_ItemStyle
                        .toModifier()
                        .cursor(Cursor.Pointer)
                ) {
                    MyFaIcon(
                        id = "emailSocialIconId",
                        modifier = Modifier.margin(leftRight = 5.px),
                        size = 20,
                        faIconsClassName = Resources.FaIconsClassName.Email_ICO
                    )
                    SpanText(
                        modifier = Modifier
                            .fontSize(15.px)
                            .fontStyle(FontStyle.Normal)
                            .margin(topBottom = 10.px),
                        text = "cybersoftsolution_dev@gmail.com"
                    )
                }
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center,
                    modifier = Selected_ItemStyle
                        .toModifier()
                        .cursor(Cursor.Pointer)
                ) {
                    MyFaIcon(
                        id = "locationSocialIconId",
                        modifier = Modifier.margin(leftRight = 5.px),
                        size = 20,
                        faIconsClassName = Resources.FaIconsClassName.Location_ICO
                    )
                    SpanText(
                        modifier = Modifier
                            .fontSize(15.px)
                            .fontStyle(FontStyle.Normal)
                            .margin(topBottom = 10.px),
                        text = "Miami, Florida, Estados Unidos"
                    )

                }
            }

        }

        Column {
            SpanText(
                modifier = Modifier
                    .fontSize(14.px)
                    .fillMaxWidth()
                    .textAlign(TextAlign.Center)
                    .fontStyle(FontStyle.Oblique)
                    .color(Theme.HalfWithe.rgb)
                    .margin(topBottom = 10.px),
                text = "Se parte de nuestra comunidad y siguenos en nuestras redes"
            )

            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center,
                modifier = Modifier.margin(topBottom = 10.px)
            ) {

                MyFaIcon(
                    id = "facebookSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Facebook_ICO

                )
                MyFaIcon(
                    id = "instagramSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Instagram_ICO
                )
                MyFaIcon(
                    id = "youtubeSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Youtube_ICO
                )
                MyFaIcon(
                    id = "twitterSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Twitter_ICO
                )
                MyFaIcon(
                    id = "tiktokSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Tiktok_ICO
                )
                MyFaIcon(
                    id = "linkedinSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Linkedin_ICO
                )
                MyFaIcon(
                    id = "githubSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Github_ICO
                )
                MyFaIcon(
                    id = "whatsappSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Whatsapp_ICO
                )
                MyFaIcon(
                    id = "telegramSocialIconId",
                    modifier = Modifier.margin(leftRight = 5.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    size = socialIconSize,
                    faIconsClassName = Resources.FaIconsClassName.Telegram_ICO
                )

            }
        }

        if (!isDesktop()) {
            HorizontalDivider(
                modifier = Modifier.margin(topBottom = 30.px)
            )
        }



    }

    @Composable
    fun AboutUsSubSection(){

        SpanText(
            modifier = Modifier
//                .cursor(Cursor.Pointer)
                .fontSize(16.px)
                .fontStyle(FontStyle.Normal)
                .color(Theme.Withe.rgb)
                .margin(topBottom = 10.px),
            text = "Sobre nosotros"
        )
        SpanText(
            modifier = Selected_ItemStyle.toModifier()
                .cursor(Cursor.Pointer)
                .fontSize(14.px)
                .fontStyle(FontStyle.Oblique)
                .margin(topBottom = 3.px),
            text = "Inicio"
        )
        SpanText(
            modifier = Selected_ItemStyle.toModifier()
                .cursor(Cursor.Pointer)
                .fontSize(14.px)
                .fontStyle(FontStyle.Oblique)
                .margin(topBottom = 3.px),
            text = "Terminos y condiciones"
        )
        SpanText(
            modifier = Selected_ItemStyle.toModifier()
                .cursor(Cursor.Pointer)
                .fontSize(14.px)
                .fontStyle(FontStyle.Oblique)
                .margin(topBottom = 3.px),
            text = "Preguntas frecuentes"
        )
        SpanText(
            modifier = Selected_ItemStyle.toModifier()
                .cursor(Cursor.Pointer)
                .fontSize(14.px)
                .fontStyle(FontStyle.Oblique)
                .margin(topBottom = 3.px),
            text = "Quines somos"
        )
        SpanText(
            modifier = Selected_ItemStyle.toModifier()
                .cursor(Cursor.Pointer)
                .fontSize(14.px)
                .fontStyle(FontStyle.Oblique)
                .margin(topBottom = 3.px),
            text = "Garantias"
        )
        SpanText(
            modifier = Selected_ItemStyle.toModifier()
                .cursor(Cursor.Pointer)
                .fontSize(14.px)
                .fontStyle(FontStyle.Oblique)
                .margin(topBottom = 3.px),
            text = "Ubicaciones"
        )
        HorizontalDivider(
            modifier = Modifier.margin(topBottom = 30.px)
        )

    }

    @Composable
    fun SubscribeSubSection(
        email: String = "",
        isSubscribe: Boolean = false,
        isSubscribing: Boolean = false,
        onEmailChange: (String) -> Unit = {},
        onSubscribe: (email: String) -> Unit = {},
        onUnSubscribe: (email: String) -> Unit = {}
    ){
            Column(
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxSize()
            ) {
                SpanText(
                    modifier = Modifier
//                .cursor(Cursor.Pointer)
                        .fontSize(16.px)
                        .fontStyle(FontStyle.Normal)
                        .color(if (!isSubscribe) Theme.Withe.rgb else Theme.HalfWithe.rgb)
                        .margin(top = 10.px),
                    text = if (isSubscribe) "Gracias por suscribirte" else "Suscribite"
                )
                SpanText(
                    modifier = Modifier
//                .cursor(Cursor.Pointer)
                        .fontSize(14.px)
                        .fillMaxWidth(350.px)
                        .textAlign(TextAlign.Center)
                        .fontStyle(FontStyle.Oblique)
                        .color(if (!isSubscribe) Theme.Withe.rgb else Theme.HalfWithe.rgb)
                        .margin(bottom = 10.px),
                    text =if (isSubscribe) "Estaras recibiendo las ultimas noticias de Cyber Soft Solution a la siguiente direccion de correo electronico" else "Y recibe las ultimas noticias de Cyber Soft Solution"
                )


                SubscribeBarCollapsable(
                    modifier = Modifier
                        .margin(left = 0.px),
                    maxWidth = 350,
                    placeHolder = "Introduce tu email",
                    email = email,
                    id = "subscribeBarCollapsableId", //_BoxContainer
                    onEmailChange = {
                        onEmailChange(it)
                    },
                    style = SubscribeBarCollapsableStyle,
                    onSubscribe = { email ->
                        onSubscribe(email)
                    },
                    onUnSubscribe = { email ->
                        onUnSubscribe(email)
                    },
                    isSubscribe = isSubscribe,
                    isSubscribing = isSubscribing,

                )
            }

    }

    @Composable
    fun DownloadAppSubSection(
        modifier: Modifier = Modifier
    ){
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceEvenly,
            modifier = Modifier
                .fillMaxWidth()
                .height(50.px)
                .margin(topBottom = 10.px)
        ) {
            Image(
                modifier = Modifier
                        .fillMaxWidth(40.percent)
                        .fillMaxHeight()
//                    .aspectRatio(19.9)
//                    .fillMaxWidth(40.percent)
//                    .height(50.px)
//                    .width(150.px),
                        ,
                src = Resources.Images.app_store,
                alt = "App Store",
            )
            Image(
                modifier = Modifier
                    .fillMaxWidth(40.percent)
                    .fillMaxHeight()
//                    .aspectRatio(4)
//                    .fillMaxWidth(40.percent)
//                    .height(50.px)
//                    .width(150.px)
                    ,
                src = Resources.Images.play_store,
                alt = "Google Play Store",
            )
        }
    }